
import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Journalist } from "@/components/reader-home/types";

interface JournalistItemProps {
  journalist: Journalist;
}

const JournalistItem = ({ journalist }: JournalistItemProps) => {
  return (
    <Link 
      key={journalist.id} 
      to={`/journalist/${journalist.id}`}
      className="block"
    >
      <div className="flex items-center p-2 rounded-lg hover:bg-accent cursor-pointer">
        <div className="relative">
          <Avatar className="h-10 w-10">
            <AvatarImage src={journalist.avatar} alt={journalist.name} />
            <AvatarFallback>{journalist.name ? journalist.name.substring(0, 2) : 'JN'}</AvatarFallback>
          </Avatar>
          {journalist.unread > 0 && (
            <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground rounded-full w-5 h-5 flex items-center justify-center text-xs">
              {journalist.unread}
            </span>
          )}
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium">{journalist.name}</p>
        </div>
      </div>
    </Link>
  );
};

export default JournalistItem;
